import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    debug: true,
    fallbackLng: "en",
    resources: {
      en: {
        translation: {
          home: "Home",
          about_us: "About Us",
          contact_us: "Contact us",
          select_the_branch: "Select the branch",
          join_now: "Join now",
          logout: "Logout",
          welcome: "Welcome",
          login_page_description:
            "Enter your information below to login to your account",
          number: "Number",
          sign_in: "Sign In",
          processing: "Processing...",
          dont_have_an_account: "Don’t Have an Account?",
          sign_up: "Sign Up",
          already_have_an_account: "Already Have an Account?",
          be_a_part_of_saloon_family: "Be a part of Saloon Family",
          enter_otp_code_here: "Enter OTP code here",
          next: "Next",
          loading: "Loading...",
          discover_the_gorgeous_shine_within_us:
            "Discover the Gorgeous Shine Within Us",
          book_your_appointment: "Book Your Appointment",
          we_provide_a_full_range_of_services:
            "We Provide a Full Range of Services",
          category: "Category",
          book_now: "Book Now",
          an_atmosphere_of_serenity_comfort:
            "An Atmosphere of serenity & Comfort",
          about_saloon_services: "About Saloon Services",
          learn_more: "Learn More",
          saloon: "SALOON",
          services: "SERVICES",
          location: "Location",
          email_address: "Email Address",
          privacy_policy: "Privacy policy",
          select_service: "Select Service",
          add_to_list: "Add to list",
          select_a_date_time: "Select a Date & Time",
          select_employee: "Select Employee",
          all: "All",
          available: "Available",
          no_employee_found: "No Employee Found.",
          load_more: "Load More",
          book: "Book",
          see_schedule: "See Schedule",
          about_employee: "About Employee",
          continue: "Continue",
          add_more: "Add more",
          checkout: "Checkout",
          cart: "Cart",
          service: "Service",
          date: "Date",
          time: "Time",
          employee: "Employee",
          charges: "Charges",
          sar: "SAR",
          edit: "Edit",
          cancel: "Cancel",
          billing_summary: "Billing Summary",
          branch: "Branch",
          price: "Price",
          discount: "Discount",
          tax: "Tax",
          total: "Total",
          enter_coupon: "Enter coupon",
          send_code: "Send Code",
          cancellation_policy: "Cancellation policy",
          pay_at_store: "Pay at store",
          your_booking_has_been_done_successfully:
            "Your booking has been done successfully!",
          escape_spa: "Escape SPA",
          ok: "Ok",
          book_a_new_appointment: "Book A New Appointment",
          upcoming_appointments: "Upcoming Appointments",
          previous_appointments: "Previous Appointments",
          no_data_found: "No Data Found...",
          not_specified: "Not Specified",
          review: "Review",
          give_review: "Give Review",
          good: "Good!",
          comment_here: "Comment here.... ",
          rate_us: "Rate us",
          continue_booking: "Continue Booking",
          our_vision: "Our Vision",
          why_choose_us: "Why Choose US",
          get_in_touch_with_us: "Get in Touch with Us",
          name: "Name",
          email: "Email",
          subject: "Subject",
          save: "Submit",
          please_enter_name: "Please enter name.",
          please_enter_email: "Please enter email.",
          enter_valid_email: "Enter valid email",
          enter_the_subject: "Enter the subject.",
          in_order_to_book_your_appointment_please_login_first:
            "In order to book your appointment please login first",
          select_a_service_first: "Select a service first",
          login_failed: "Login Failed",
          signup_failed: "Signup Failed",
          please_enter_number: "Please enter number.",
          enter_valid_number: "Enter valid number.",
          please_enter_otp: "Please enter OTP.",
          invalid_code: "Invalid code",
          please_select_a_time_slot: "Please select a time slot",
          type_something_to_search: "Type something to search...",
          search_here: "Search here.........",
          cart_is_empty: "Cart is Empty",
          please_enter_code: "Please enter code.",
          failed_to_add_coupon: "Failed to Add Coupon",
          you_have_availed_the_discount: "You have availed the discount.",
          invalid_coupon_code: "Invalid Coupon Code.",
          please_rate_first: "Please rate first.",
          please_enter_review: "Please enter review.",
          failed_please_try_again: "Failed, please try again.",
          failed_please_check_your_connection:
            "Failed, please check your connection.",
          your_response_has_been_sent_successfully_our_support_team_will_contact_you_shortly:
            "Your response has been sent successfully, our support team will contact you shortly.",
          please_upload_picture: "Please Upload Picture",
          notifications: "Notifications",
          edit_profile: "Edit profile",
          unread_notification: "Unread Notification",
          read_notification: "Read Notification",
          mark_as_read: "Mark as read",
          mark_as_unread: "Mark as unread",
          my_booking: "My Bookings",
          chs_srvc: "Choose a Service",
          two_srvc: "2 services",
          sln_srvc: "Branch Service",
          hm_srvc: "Home Service",
          slct_gndr: "Select Gender",
          male: "Male",
          female: "Female",
          slct_lction: "Choose Location",
          east: "East",
          west: "West",
          cntnue: "Continue",
          enter_address: "Enter Address",
          pay_aft: "Pay after service",
          err_add: "Select location from Map",
          gender_desc:
            "Specify gender here, so we can assign a therapist of your gender for your service",
          chose_loc: "Choose Your Location",
        },
      },
      ar: {
        translation: {
          home: "الصفحة الرئيسية",
          about_us: "معلومات عنا",
          contact_us: "اتصل بنا",
          select_the_branch: "حدد الفرع",
          join_now: "نضم الان",
          logout: "تسجيل خروج",
          welcome: "مرحباً",
          login_page_description:
            "أدخل المعلومات الخاصة بك أدناه لتسجيل الدخول إلى حسابك",
          number: "رقم",
          sign_in: "تسجيل الدخول",
          processing: "يعالج...",
          dont_have_an_account: "ليس لديك حساب؟",
          sign_up: "اشتراك",
          already_have_an_account: "هل لديك حساب؟",
          be_a_part_of_saloon_family: "كن جزءًا من عائلة الصالون",
          enter_otp_code_here: "أدخل رمز OTP هنا",
          next: "التالي",
          loading: "تحميل...",
          discover_the_gorgeous_shine_within_us: "اكتشف اللمعان الرائع بداخلنا",
          book_your_appointment: "احجز موعدك",
          we_provide_a_full_range_of_services:
            "نحن نقدم مجموعة كاملة من الخدمات",
          category: "فئة",
          book_now: "احجز الآن",
          an_atmosphere_of_serenity_comfort: "جو من الصفاء والراحة",
          about_saloon_services: "حول خدمات الصالون",
          learn_more: "يتعلم أكثر",
          saloon: "صالون",
          services: "خدمات",
          location: "موقع",
          email_address: "عنوان البريد الإلكتروني",
          privacy_policy: "سياسة الخصوصية",
          select_service: "حدد الخدمة",
          add_to_list: "أضف إلى القائمة",
          select_a_date_time: "حدد التاريخ والوقت",
          select_employee: "حدد الموظف",
          all: "الجميع",
          available: "متاح",
          no_employee_found: "لم يتم العثور على موظف.",
          load_more: "تحميل المزيد",
          book: "كتاب",
          see_schedule: "انظر الجدول",
          about_employee: "حول الموظف",
          continue: "يكمل",
          add_more: "أضف المزيد",
          checkout: "الدفع",
          cart: "عربة التسوق",
          service: "خدمة",
          date: "تاريخ",
          time: "وقت",
          employee: "موظف",
          charges: "رسوم",
          sar: "ريال سعودي",
          edit: "يحرر",
          cancel: "يلغي",
          billing_summary: "ملخص الفوترة",
          branch: "الفرع",
          price: "سعر",
          discount: "تخفيض",
          tax: "ضريبة",
          total: "المجموع",
          enter_coupon: "أدخل القسيمة",
          send_code: "أرسل الرمز",
          cancellation_policy: "سياسة الإلغاء",
          pay_at_store: "ادفع في المتجر",
          your_booking_has_been_done_successfully: "تم الحجز الخاص بك بنجاح!",
          escape_spa: "إسكيب سبا",
          ok: "نعم",
          book_a_new_appointment: "احجز موعدًا جديدًا",
          upcoming_appointments: "المواعيد القادمة",
          previous_appointments: "المواعيد السابقة",
          no_data_found: "لاتوجد بيانات...",
          not_specified: "غير محدد",
          review: "مراجعة",
          give_review: "قدِّم مراجعة",
          good: "جيد!",
          comment_here: "التعليق هنا ....",
          rate_us: "قيمنا",
          continue_booking: "استمر في الحجز",
          our_vision: "رؤيتنا",
          why_choose_us: "لماذا أخترتنا",
          get_in_touch_with_us: "ابق على تواصل معنا",
          name: "اسم",
          email: "بريد إلكتروني",
          subject: "موضوع",
          save: "يُقدِّم",
          please_enter_name: "الرجاء إدخال الاسم.",
          please_enter_email: "الرجاء إدخال البريد الإلكتروني.",
          enter_valid_email: "أدخل بريدًا إلكترونيًا صالحًا",
          enter_the_subject: "أدخل الموضوع.",
          in_order_to_book_your_appointment_please_login_first:
            "من أجل حجز موعدك يرجى تسجيل الدخول أولا",
          select_a_service_first: "حدد الخدمة أولا",
          login_failed: "فشل تسجيل الدخول",
          signup_failed: "فشل انشاء الحساب",
          please_enter_number: "الرجاء إدخال الرقم.",
          enter_valid_number: "أدخل رقمًا صالحًا.",
          please_enter_otp: "الرجاء إدخال OTP.",
          invalid_code: "الرمز غير صحيح",
          please_select_a_time_slot: "الرجاء تحديد فترة زمنية",
          type_something_to_search: "اكتب شيئًا للبحث فيه ...",
          search_here: "ابحث هنا.........",
          cart_is_empty: "البطاقه خاليه",
          please_enter_code: "الرجاء إدخال الرمز.",
          failed_to_add_coupon: "فشل في إضافة القسيمة",
          you_have_availed_the_discount: "لقد استفدت من الخصم.",
          invalid_coupon_code: "رقم قسيمه غير صالح.",
          please_rate_first: "يرجى التقييم أولا.",
          please_enter_review: "الرجاء إدخال المراجعة.",
          failed_please_try_again: "فشل ، يرجى المحاولة مرة أخرى.",
          failed_please_check_your_connection:
            "فشل ، يرجى التحقق من الاتصال الخاص بك.",
          your_response_has_been_sent_successfully_our_support_team_will_contact_you_shortly:
            "تم إرسال ردك بنجاح ، وسيقوم فريق الدعم لدينا بالاتصال بك قريبًا.",
          please_upload_picture: "الرجاء تحميل الصورة",
          notifications: "إشعارات",
          edit_profile: "تعديل الملف الشخصي",
          unread_notification: "إعلام غير مقروء",
          read_notification: "قراءة الإخطار",
          mark_as_read: "ضع إشارة مقروء",
          mark_as_unread: "وضع علامةغير مقروءة",
          my_booking: "حجوزاتي",
          chs_srvc: "اختر خدمة",
          two_srvc: "2 خدمات",
          sln_srvc: "خدمة الفروع",
          hm_srvc: "خدمة منزلية",
          slct_gndr: "حدد نوع الجنس",
          male: "ذكر",
          female: "أنثى",
          slct_lction: "اختيار موقع",
          east: "شرق",
          west: "الغرب",
          cntnue: "يكمل",
          enter_address: "أدخل العنوان",
          pay_aft: "الدفع بعد الخدمة",
          err_add: "اختر الموقع من الخريطة",
          gender_desc: "حدد الجنس هنا، حتى نتمكن من تعيين معالج من جنسك لخدمتك",
          chose_loc: "اختر موقعك",
        },
      },
    },
  });
